module.exports = __webpack_public_path__ + "static/media/evcharger.e4e946ec.png";